export const eventRoutes = {
    default: (event) => {
        //console.log('eventRoutes.default', event.detail.call);

        let { name, payload, call, type } = event.detail;

        if(typeof call === 'function'){
            call(event);
        }
    }
};